const config = {
    getPuzzleUrl : "https://qw56x3lal0.execute-api.us-west-1.amazonaws.com/dev/sudoku/restapi/puzzle"
};

export default config;